import React from 'react';

import { Outlet } from 'react-router-dom';

const ProcurementContent = () => {
  return <Outlet />;
};

export default ProcurementContent;
